import { Text, View, StyleSheet } from "@react-pdf/renderer";
import PropTypes from "prop-types";

const styles = StyleSheet.create({
  section: {
    marginBottom: 15,
    padding: 10,
    border: "1 solid #f0f0f0",
    borderRadius: 4,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 8,
    color: "#333",
  },
  table: {
    display: "table",
    width: "auto",
    marginBottom: 10,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#e0e0e0",
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#e0e0e0",
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#f5f5f5",
    fontWeight: "bold",
    padding: 5,
    fontSize: 9,
  },
  tableCol: {
    width: "25%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#e0e0e0",
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
    fontSize: 8,
  },
});

const ReporteResumenEc2 = ({ data }) => {
  // Inicialización de variables
  let totalIndisponibilidad = 0;
  let sumCpu = 0;
  let sumRam = 0;
  let count = 0;
  let timeAnterior = 0;

  const rows = data?.infoEc2?.rows || [];

  for (let objRow of rows) {
    let timeAct = parseInt(objRow.t) - 3600 * 5;

    if (timeAnterior > 0) {
      const delta = timeAct - timeAnterior;
      if (delta >= 300) {
        totalIndisponibilidad += (delta - 300) / 60;
      }
    }

    timeAnterior = timeAct;
    sumCpu += parseFloat(objRow.c);
    sumRam += parseFloat(objRow.r);
    count++;
  }

  const timeDisponibleMes = 60 * 24 * 30;
  const disponibilidadTotal = timeDisponibleMes - totalIndisponibilidad;
  const availabilityPercentage = (disponibilidadTotal / timeDisponibleMes) * 100;
  const availabilityPercentageNo = (totalIndisponibilidad / timeDisponibleMes) * 100;

  const avgCpu = count > 0 ? sumCpu / count : 0;
  const avgRam = count > 0 ? sumRam / count : 0;

  function formatoHorasMinutos(minutosTotales) {
    const horas = Math.floor(minutosTotales / 60);
    const minutos = Math.round(minutosTotales % 60);
    return `${horas} horas y ${minutos} minutos`;
  }

  return (
    <View style={styles.section}>
      <Text style={styles.sectionTitle}>Resumen de recursos (CPU, Memoria, Disponibilidad)</Text>

      <View style={styles.table}>
        <View style={styles.tableRow}>
          <Text style={styles.tableColHeader}>Promedio CPU (%)</Text>
          <Text style={styles.tableColHeader}>Promedio RAM (%)</Text>
          <Text style={styles.tableColHeader}>Periodo de Inactividad</Text>
          <Text style={styles.tableColHeader}>% de Inactividad</Text>
          <Text style={styles.tableColHeader}>% de Disponibilidad</Text>
        </View>

        <View style={styles.tableRow}>
          <Text style={styles.tableCol}>{avgCpu.toFixed(2)}%</Text>
          <Text style={styles.tableCol}>{avgRam.toFixed(2)}%</Text>
          <Text style={styles.tableCol}>{formatoHorasMinutos(totalIndisponibilidad)}</Text>
          <Text style={styles.tableCol}>{availabilityPercentageNo.toFixed(2)}%</Text>
          <Text style={styles.tableCol}>{availabilityPercentage.toFixed(2)}%</Text>
        </View>
      </View>
    </View>
  );
};

ReporteResumenEc2.propTypes = {
  data: PropTypes.shape({
    infoEc2: PropTypes.shape({
      rows: PropTypes.arrayOf(
        PropTypes.shape({
          t: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          c: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          r: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })
      ),
    }),
  }),
};

export default ReporteResumenEc2;
